import {ssrSafeLocation} from '@github-ui/ssr-utils'

export const replacePageNumberInUrl = (url: string, pageNumber: number): string => {
  const urlObject = new URL(url, ssrSafeLocation.origin)
  urlObject.searchParams.set('page', pageNumber.toString())
  return urlObject.toString()
}

export const appendFeatureFlagsToUrl = (url: string, featureFlags?: string): string => {
  const urlObject = new URL(url, ssrSafeLocation.origin)

  if (featureFlags) {
    urlObject.searchParams.set('_features', featureFlags)
  }

  return urlObject.toString()
}

export const MOBILE_DOWNLOAD_PARAM = 'mobile_download'

export function resolveNativeShareUrl(destination: string, currentUrl: string): string {
  const value = destination
  const invalidUrlMessage = 'Share destination must be an absolute HTTP(S) URL or a root-relative path'

  for (const character of value) {
    const code = character.charCodeAt(0)
    if (/\s/u.test(character) || code <= 0x20 || (code >= 0x7f && code <= 0x9f) || character === '\\') {
      throw new TypeError(invalidUrlMessage)
    }
  }

  const isRootRelative = value.startsWith('/') && !value.startsWith('//')
  const origin = new URL(currentUrl, ssrSafeLocation.origin || undefined).origin
  const resolved = new URL(value, origin)

  if (
    (resolved.protocol !== 'https:' && resolved.protocol !== 'http:') ||
    (!isRootRelative &&
      (!value.toLowerCase().startsWith(`${resolved.protocol}//`) || value[resolved.protocol.length + 2] === '/'))
  ) {
    throw new TypeError(invalidUrlMessage)
  }

  return resolved.href
}

export const withMobileDownloadParam = (url: string): string => {
  try {
    const urlObject = new URL(url, ssrSafeLocation.origin)
    urlObject.searchParams.set(MOBILE_DOWNLOAD_PARAM, 'true')
    return urlObject.toString()
  } catch {
    return url
  }
}
